var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"theme-logo",style:(_vm.logoStyle),attrs:{"src":_vm.logoSrc,"alt":_vm.altText}})}
var staticRenderFns = []

export { render, staticRenderFns }